/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { userTokenService, Constants } from '@pwc/pwc-deals-web-common';
import { isInlineCommentingEnabled } from 'common/helpers/featureFlags';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getOpenedProjectStatusSafe } from 'features/project/projectSlice';
import { useIsNonCommentableContent } from './useIsNonCommentableContent';
import {
  isProjectArchived,
  isProjectInactive,
} from '../helpers/projectStatusesUtils';
import { useAddCommentFlagService } from './useAddCommentFlagService';

const { InlineCommentFeatureFlags } = Constants;

type UseParams = {
  projectId?: string;
};

export const useIsAddingCommentEnabled = (): boolean => {
  const { addOrRemoveIf, contains } = useAddCommentFlagService();

  addOrRemoveIf(
    !isInlineCommentingEnabled,
    InlineCommentFeatureFlags.FeatureDisabled
  );

  const { projectId } = useParams<UseParams | undefined>() || {};
  const projectStatus = useSelector(getOpenedProjectStatusSafe);
  const isReadOnly = userTokenService.isPwcReadOnlyRole(projectId);
  const isNonCommentableContent = useIsNonCommentableContent();

  addOrRemoveIf(isReadOnly, InlineCommentFeatureFlags.ReadOnlyUser);

  addOrRemoveIf(
    isNonCommentableContent,
    InlineCommentFeatureFlags.NonCommentableContent
  );

  addOrRemoveIf(
    isProjectArchived(projectStatus),
    InlineCommentFeatureFlags.ProjectArchived
  );

  addOrRemoveIf(
    isProjectInactive(projectStatus),
    InlineCommentFeatureFlags.ProjectInactive
  );

  return !contains(Constants.INLINE_COMMENT_HIDE_ADD_COMMENT_FLAGS);
};
